module.exports = __webpack_public_path__ + "assets/img/21.04b07e2f.png";